import React, {Fragment} from 'react';
import {fetchReturnInfo} from "../actions/returns";
import {connect} from "react-redux";
import ReactLoading from 'react-loading';


class ReturnTicketInfo extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      ticketInfo: null
    }
  }

  componentDidMount(){

    const { dispatch, purchaseId } = this.props;
    dispatch(fetchReturnInfo(purchaseId)).then(({response}) => {

      if(response && response.length > 0)
        this.setState({ ticketInfo: response[0].ticketSet });

    });

  }

  generateHtml(ticketInfo, colspan){

    return (<Fragment>
      {
        ticketInfo.map(t => {

          const className = t.used ? "label label-success" : "label label-warning";
          const text = t.used ? "Ticket validated" : "Not yet validated";

          return (
            <tr key={t.ticketId}>
              <td/>
              <td className="returnTicketInfo">
                <span>Ticket Id: </span>
                <span>{t.ticketId}</span>
              </td>
              <td className="returnTicketInfo" colSpan={colspan}>
                <span>Status: </span>
                <span className={className}>{text}</span>
              </td>
            </tr>)

        })
      }
    </Fragment>);
  }

  render(){

    const { ticketInfo } = this.state;
    const { colspan } = this.props;

    const html = ticketInfo === null ? <tr>
      <td/>
      <td>
        <div className="loader">
          <ReactLoading color="gray" type="bubbles" height="40px" width="40px"/>
        </div>
      </td>
    </tr> : this.generateHtml(ticketInfo, colspan);
    return <Fragment> { html } </Fragment>;
  }
}

export default connect()(ReturnTicketInfo);